import React from 'react';
import '../styles/legalpage.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal-bg">
      <div className="legal-card">
        <h1>Privacy Policy</h1>
        <p className="legal-intro">At ABBASS Global Properties LLC, accessible at <a href="https://www.abbassglobalproperties.com/" target="_blank" rel="noopener noreferrer">https://www.abbassglobalproperties.com/</a>, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services. Please read this policy carefully. If you do not agree with the terms of this Privacy Policy, please do not use our website or services.</p>
        <h2 className="legal-section-title">1. Information We Collect</h2>
        <h3>1.1 Personal Information:</h3>
        <p>When you interact with us, we may collect personal information that you provide, such as:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Address</li>
          <li>Other information relevant to the service we provide</li>
        </ul>
        <h3>1.2 Automatically Collected Information:</h3>
        <p>When you visit our website, certain information is automatically collected, such as:</p>
        <ul>
          <li>Your IP address</li>
          <li>Browser type and version</li>
          <li>Operating system</li>
          <li>Pages you visit and the time spent on those pages</li>
          <li>Referring website URLs</li>
        </ul>
        <h3>1.3 Cookies:</h3>
        <p>We may use cookies to enhance your browsing experience. Cookies are small files stored on your device that track and save information about your interactions with our website. You can modify your browser settings to decline cookies if you prefer.</p>
        <h2 className="legal-section-title">2. How We Use Your Information</h2>
        <p>The information we collect may be used for:</p>
        <ul>
          <li>Providing and managing our services</li>
          <li>Communicating with you regarding inquiries or transactions</li>
          <li>Improving our website and services</li>
          <li>Personalizing your experience</li>
          <li>Conducting internal business analysis</li>
          <li>Complying with legal obligations</li>
        </ul>
        <h2 className="legal-section-title">3. Sharing Your Information</h2>
        <p>We do not sell, rent, or trade your personal information. However, we may share your information with:</p>
        <ul>
          <li>Service providers who assist us in operating our business and delivering services to you</li>
          <li>Legal or regulatory authorities if required by law</li>
          <li>Third parties in connection with a business transaction, such as a merger, acquisition, or sale of assets</li>
        </ul>
        <h2 className="legal-section-title">4. Data Retention</h2>
        <p>We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law.</p>
        <h2 className="legal-section-title">5. Protecting Your Information</h2>
        <p>We implement appropriate technical and organizational measures to safeguard your information from unauthorized access, disclosure, or destruction. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>
        <h2 className="legal-section-title">6. Your Rights</h2>
        <p>You have the following rights concerning your personal information:</p>
        <ul>
          <li>Access: You may request a copy of the personal information we hold about you.</li>
          <li>Correction: You may request corrections to inaccurate or incomplete information.</li>
          <li>Deletion: You may request that we delete your personal information, subject to legal or contractual obligations.</li>
          <li>Objection: You may object to the processing of your data for certain purposes.</li>
        </ul>
        <p>To exercise any of these rights, please contact us at <a href="mailto:info@abbass.group">info@abbass.group</a>.</p>
        <h2 className="legal-section-title">7. Third-Party Websites</h2>
        <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of such websites. We encourage you to read their privacy policies when visiting them.</p>
        <h2 className="legal-section-title">8. Updates to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. We encourage you to review this policy periodically. The “Last Updated” date at the top of this page indicates when the policy was last revised.</p>
        <h2 className="legal-section-title">9. Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy or our practices, please contact us at:</p>
        <address>
          <strong>ABBASS Global Properties LLC</strong><br />
          Ontario Tower, Business Bay, Dubai<br />
          Phone: +971 50 322 7603<br />
          Email: <a href="mailto:info@abbass.group">info@abbass.group</a>
        </address>
      </div>
    </div>
  );
} 